import IconCaution from './caution.svg'
import DarkIconPassword from './dark/password.png'
import DarkIconPhone from './dark/phone.png'
import DarkIcon2sv from './dark/recent-activity-2sv.svg'
import DarkIconSignIn from './dark/recent-activity-signin.svg'
import DarkIconUpdated from './dark/recent-activity-updated.svg'
import IconPassword from './password.svg'
import IconPhone from './phone.svg'
import Icon2sv from './recent-activity-2sv.svg'
import IconSignIn from './recent-activity-signin.svg'
import IconUpdated from './recent-activity-updated.svg'

const SecurityIcon = {
  IconSignIn: { light: IconSignIn, dark: DarkIconSignIn },
  Icon2sv: { light: Icon2sv, dark: DarkIcon2sv },
  IconUpdated: { light: IconUpdated, dark: DarkIconUpdated },
  IconPassword: { light: IconPassword, dark: DarkIconPassword },
  IconPhone: { light: IconPhone, dark: DarkIconPhone },
  IconCaution: { light: IconCaution, dark: IconCaution }
}

export const getSecurityIcon = (type, mode = 'light') => {
  const icon = SecurityIcon[type]

  if (mode === 'dark') {
    return icon.dark ? icon.dark : icon.light
  }

  return icon.light
}
